import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Global request interceptor to add language header to all requests
api.interceptors.request.use((config) => {
  // Get current language from localStorage
  const language = localStorage.getItem('sa_lang') || 'en';
  config.headers['X-Language'] = language;
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  session: (session_id) => api.post('/auth/session', { session_id }),
  logout: () => api.post('/auth/logout'),
  verifyEmail: (token) => api.post('/auth/verify-email', { token }),
  resendVerification: (email, lang = 'en') => api.post('/auth/resend-verification', { email, lang }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token, new_password) => api.post('/auth/reset-password', { token, new_password }),
};

// Audit
export const auditAPI = {
  upload: (file, language, onProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/audit/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data', 'X-Language': language },
      onUploadProgress: onProgress,
      timeout: 120000,
    });
  },
  history: () => api.get('/audit/history'),
  detail: (id) => api.get(`/audit/${id}`),
  downloadPdf: (id) => api.get(`/audit/${id}/pdf`, { responseType: 'blob' }),
  downloadCsv: (id, language = 'en') => api.get(`/audit/${id}/csv?lang=${language}`, { responseType: 'blob' }),
  delete: (id) => api.delete(`/audit/${id}`),
};

// Billing
export const billingAPI = {
  checkout: (origin_url, plan_id = 'auditor', currency = 'usd', lang = 'en', interval = 'year') => api.post('/billing/checkout', { origin_url, plan_id, currency, lang, interval }),
  status: (session_id) => api.get(`/billing/status/${session_id}`),
  subscription: () => api.get('/billing/subscription'),
  portal: () => api.post('/billing/portal'),
};

// Contact (B2B)
export const contactAPI = {
  submit: (data) => api.post('/contact', data),
};

// Admin (God Mode)
export const adminAPI = {
  stats: () => api.get('/admin/stats'),
  users: () => api.get('/admin/users'),
  adjustAudits: (userId, adjustment, reason) => api.post(`/admin/users/${userId}/adjust_audits`, { adjustment, reason }),
  deleteUser: (userId) => api.delete(`/admin/users/${userId}`),
  auditLogs: (limit = 100) => api.get(`/admin/audits/logs?limit=${limit}`),
};

export default api;
